import styled from 'styled-components'

export const Text = styled.div`
  color: ${({ theme }) => theme.FontColor};
  font-size: 12px;
  padding: 6px;
  margin: 0;
  text-align: left;
`
